import { IApplicationState } from '../../types/redux';

export function selectDealSaleB2bPromoUrl(state: IApplicationState) {
  return state.links.dealSaleB2bPromoUrl;
}
